import { AutogenLayoutDataFusionErrorQuickInfo } from "./autogen/AutogenLayoutDataFusionErrorQuickInfo";

export class DataFusionErrorQuickInfo extends AutogenLayoutDataFusionErrorQuickInfo {

}
